import { SubText, Text } from '@procurify/ui'

import { Price } from '@webapp/core/components/Price'
import { useFormatPercent } from '@webapp/hooks/useFormatPercent'
import { SpendVarianceStyled } from './styles/SpendVarianceStyled'

export interface ISpendVarianceProps {
  variance?: number | string
  variancePercentage?: number | string
  isOverBudget?: boolean
  useSystemLocale?: boolean
  minimumFractionDigits?: number
  maximumFractionDigits?: number
}

export const SpendVariance = ({
  variance = null,
  variancePercentage = null,
  isOverBudget = false,
  useSystemLocale = true,
  minimumFractionDigits = 0,
  maximumFractionDigits = 0,
}: ISpendVarianceProps) => {
  const formatPercent = useFormatPercent({ useSystemLocale })

  return (
    <SpendVarianceStyled>
      {variance !== null && variancePercentage !== null ? (
        <>
          (
          {formatPercent(
            variancePercentage,
            minimumFractionDigits,
            maximumFractionDigits
          )}
          )
          <Price
            color={isOverBudget ? 'danger' : 'textPrimary'}
            price={variance}
          />
        </>
      ) : (
        <Text>{'--'}</Text>
      )}
    </SpendVarianceStyled>
  )
}

SpendVariance.displayName = 'SpendVariance'
